import {
  ActionType as ActionTypeQuantity
} from "../product-quantity/const";

export const ActionType = Object.assign(
    {},
    ActionTypeQuantity,
    {
      REMOVE: `REMOVE`,
    }
);
